import { Provider } from "@angular/core";
import { map, Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { PersonnelRepository } from "../../repositories/personnel.repository";

interface retrieveWeeklyAbsenceParams {
  resourceId: number;
}
export class RetrieveWeeklyAbsenceUseCase
  implements UseCase<retrieveWeeklyAbsenceParams, any>
{
  constructor(private repo: PersonnelRepository) {}

  execute(param: retrieveWeeklyAbsenceParams): Observable<Object> {
    return this.repo.retrieveWeeklyAbsence(param.resourceId).pipe(
      map((response) => {
        return response;
      }),
    );
  }
}

const retrieveWeeklyAbsenceFactory = (repo: PersonnelRepository) =>
  new RetrieveWeeklyAbsenceUseCase(repo);
export const retrieveWeeklyAbsenceUseCaseProvider: Provider = {
  provide: RetrieveWeeklyAbsenceUseCase,
  useFactory: retrieveWeeklyAbsenceFactory,
  deps: [PersonnelRepository],
};
